/**
 * データエクスポート画面機能定義ファイル
 *  ・概要
 *    データエクスポート画面で使用する定義ファイル
 *  ・更新履歴
 *    2022/01/26 新規作成 小林
 */
import { FieldChildrenProp } from '@/services/hexabase/types';
/* eslint-disable @typescript-eslint/camelcase */

// データレポート取得時に使用するソート条件
export const DefaultSortRequest = [{ 'id': 'expected_sales_month', 'order': 'asc'} ];

// 入力、選択時の情報から参照先となるマスタのidを決定するリスト
export const CatchInputMasterIdList: { [k: string]: string } = {
  'customer_id': 'm_customer',
  'company_id': 'm_company',
  'manager_id': 'm_employee',
  'commodity_id': 'm_commodity',
  'leasing_company_id': 'm_leasing_company'
};

// データエクスポート画面で表示するボタン情報
export const DataExportButtons: Array<{ [key: string]: string }> = [
  {
    style: 'font-size: 1.4rem;',
    color: 'primary',
    value: 'CSV出力',
    name: 'csvoutput_sjis',
    event: 'SJIS'
  },
  {
    style: 'font-size: 1.4rem;',
    color: 'btn-secondary',
    value: 'クリア',
    name: 'clear',
    event: 'clearButton'
  }
];

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  // サービス種別用フォーム
  export const DataReportOutputSelectServiceTypeForm: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': 'サービス種別',
      'name': 'サービス種別',
      'display_id': 'service_type',
      'dataType': 'text',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_service_type',
      props: {
        label: 'サービス種別',
        name: 'service_type',
        value: '',
        columns: [],
        body: [],
        dialogTitle: 'サービス種別選択',
        outPutData: [{ label: 'サービス種別', name: 'service_type', isDisabled: true, value: '' }]
      },
      'sizeX': 1,
      'sizeY': 1,
      'col': 0,
      'row': 0,
      'show': true,
    }
  ];

  // 出力条件用フォーム
  export const DataReportOutputConditionsForm: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '売上期間',
      'name': 'expected_sales_month',
      'dataType': 'datetime',
      // 売上期間
      'display_id': 'expected_sales_month',
      component: 'DatePickerRangeArea',
      props: {
        format: 'yyyy年M月',
        type: 'month',
        labelText: '売上期間',
        nameFrom: 'expected_sales_month',
        nameTo: 'expected_sales_month',
        valueFrom: '',
        valueTo: ''
      },
      col: 0,
      row: 0,
      sizeX: 2,
      sizeY: 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': 'ステータス',
      'name': 'status',
      'display_id': 'status',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'status',
        'label': 'ステータス',
        'selectData': [],
        'isDisabled': false,
        'value': ''
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '顧客',
      'name': 'customer_id',
      'display_id': 'customer_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_customer',
      props: {
        label: '',
        name: 'customer_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '顧客選択',
        outPutData: [{ label: '顧客', name: 'customer_name', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row': 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '会社名',
      'name': 'company_id',
      'display_id': 'company_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_company',
      props: {
        label: '',
        name: 'company_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '会社名選択',
        outPutData: [{ label: '会社名', name: 'company_name', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '担当者',
      'name': 'manager_id',
      'display_id': 'manager_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_employee',
      props: {
        label: '',
        name: 'manager_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '担当者選択',
        outPutData: [{ label: '担当者', name: 'name', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row': 2,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '商材',
      'name': 'commodity_id',
      'display_id': 'commodity_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_company',
      props: {
        label: '',
        name: 'commodity_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '商材選択',
        outPutData: [{ label: '商材', name: 'commodity', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 2,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': 'リース会社',
      'name': 'leasing_company_id',
      'display_id': 'leasing_company_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_leasing_company',
      props: {
        label: '',
        name: 'leasing_company_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: 'リース会社選択',
        outPutData: [{ label: 'リース会社', name: 'leasing_company', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row' : 3,
      'show': true
    }
  ];
}
export const DataReportOutputSelectServiceTypeForm =
  optionalForm.DataReportOutputSelectServiceTypeForm;
export const DataReportOutputConditionsForm = optionalForm.DataReportOutputConditionsForm;
/* eslint-enable */
